<div *ngIf="!typeDate && !typeTimaticResidence">
    <div [class]="className" *ngIf="fieldInput?.valid && fieldInput?.value">
        <img alt="" [src]="image">
    </div>
</div>
<div *ngIf="typeDate">
    <div [class]="className" *ngIf="fieldInput?.valid && fieldInput?.value">
        <img alt="" [src]="image">
    </div>
</div>
<div *ngIf="typeTimaticResidence">
    <div [class]="className" *ngIf="fieldInput?.valid">
        <img alt="" [src]="image">
    </div>
</div>
